import React from 'react';
import clsx from 'clsx';

export interface CheckboxProps
  extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'type' | 'size'> {
  label?: React.ReactNode;
  hint?: string;
}

export const Checkbox = React.forwardRef<HTMLInputElement, CheckboxProps>(
  ({ label, hint, id, className, disabled, ...props }, ref) => {
    const autoId = React.useId();
    const fieldId = id ?? autoId;
    return (
      <label
        htmlFor={fieldId}
        className={clsx(
          'inline-flex items-start gap-2 text-[13px] text-slate-300 select-none',
          disabled && 'opacity-50 cursor-not-allowed',
          !disabled && 'cursor-pointer',
          className,
        )}
      >
        <input
          ref={ref}
          id={fieldId}
          type="checkbox"
          disabled={disabled}
          className={clsx(
            'mt-0.5 h-4 w-4 rounded-ds-sm border border-white/[0.16] bg-surface-2 accent-accent',
            'focus:outline-none focus-visible:ring-2 focus-visible:ring-accent focus-visible:ring-offset-2 focus-visible:ring-offset-surface-1',
            'disabled:cursor-not-allowed',
          )}
          {...props}
        />
        {(label || hint) && (
          <span className="flex flex-col gap-0.5">
            {label && <span>{label}</span>}
            {hint && <span className="text-[11px] text-slate-400">{hint}</span>}
          </span>
        )}
      </label>
    );
  },
);

Checkbox.displayName = 'Checkbox';

export default Checkbox;
